export default "/images/c96ff4cd230f12ef7f90bb6ad8ba16b8.avif";